import { CT_AD_ID_FILTER_FIELD } from '../CreativeTracker/constants';

export const BRAND_NAME_KEY = 'brand-name';
export const BRAND_ID_KEY = 'brand-id';
export const BRAND_CRM_IDS_KEY = 'brand-crm-ids';
export const BRAND_KEY = 'brand';
export const UPDATED_AT_KEY = 'updated-at';
export const CREATED_AT_KEY = 'created-at';
export const ASSET_NAME_KEY = 'asset-name';
export const REVIEW_STATUS_KEY = 'review-status';
export const ASSET_ID_KEY = 'asset-id';
export const ASSET_IDS_KEY = 'asset-ids';
export const TRACKING_ID_KEY = 'tracking-id';
export const ASSET_SOURCES_KEY = 'asset-sources';
export const ADOMAIN_KEY = 'adomain';
export const ADOMAINS_KEY = 'adomains';
export const PREVIEW_KEY = 'preview';
export const MEDIA_FILE_URL_KEY = 'media-url';
export const TRANSCODE_QC_PLAYLIST_KEY = 'transcode-qc-playlist';
export const DSP_ID_KEY = 'dsp-id';
export const DSP_NAME_KEY = 'dsp-name';
export const INGESTION_TYPE_KEY = 'timing';
export const SUGGESTED_BRAND_CRM_ID_KEY = 'suggested-brand-crm-id';
export const SUGGESTED_BRAND_CRM_NAME_KEY = 'suggested-brand-crm-name';
export const TRANSCODE_STATUS_KEY = 'transcode-status';
export const VIDEO_METADATA_KEY = 'video-metadata';
export const SOURCE_AD_ID_KEY = 'source-ad-id';
export const SOURCE_AD_IDS_KEY = 'source-ad-ids';
export const SOURCE_CREATIVE_ID_KEY = 'source-creative-id';
export const SOURCE_CREATIVE_IDS_KEY = 'source-creative-ids';
export const CONTENT_PARTNER_IDS_KEY = 'content-partner-ids';
export const CAMPAIGN_MANAGER_NAME_KEY = 'campaign-manager-email';
export const PUBLISHERS_KEY = 'allowed-publishers';
export const DSP_IDS_KEY = 'dsp-ids';
export const BRAND_NAMES_KEY = 'brand-names';
export const REVIEW_STATUSES_KEY = 'review-statuses';
export const LAST_UPDATED_RANGE = 'last-updated-range';
export const CREATIVE_TYPES_KEY = 'creative-types';
export const COUNTRY_CODES_KEY = 'countries';
export const TRACKING_IDS_KEY = 'tracking-ids';
export const EXTERNAL_PARTNER_KEY = 'external-partner';
export const ASSET_SOURCE_EXTERNAL_PARTNERS_KEY = 'asset-source-external-partners';
export const SUBCLASS_KEY = 'asset-source-sub-classes';
export const CREATIVE_ID_KEY = 'creative-ids';
export const INGESTION_TYPES_KEY = 'timings';
export const AD_ID_KEY = 'ad-id';

export const REVIEW_STATUS_PENDING = 'PENDING';
export const REVIEW_STATUS_PARTIAL = 'PARTIAL';
export const REVIEW_STATUS_ACCEPTED = 'ACCEPTED';
export const REVIEW_STATUS_DECLINED = 'DECLINED';

// CT Filter Fields
export const CT_PUBLISHER_FILTER_FIELD = 'CT_PUBLISHER_FILTER_FIELD';
export const CT_SOURCE_AD_ID_FILTER_FIELD = 'CT_SOURCE_AD_ID_FILTER_FIELD';
export const CT_SOURCE_CREATIVE_ID_FILTER_FIELD = 'CT_SOURCE_CREATIVE_ID_FILTER_FIELD';
export const CT_ASSET_ID_FILTER_FIELD = 'CT_ASSET_ID_FILTER_FIELD';
export const CT_BRAND_NAME_FILTER_FIELD = 'CT_BRAND_NAME_FILTER_FIELD';
export const CT_ADOMAIN_FILTER_FIELD = 'CT_ADOMAIN_FILTER_FIELD';
export const CT_DSP_FILTER_FIELD = 'CT_DSP_FILTER_FIELD';
export const CT_REVIEW_STATUS_FILTER_FIELD = 'CT_REVIEW_STATUS_FILTER_FIELD';
export const CT_LAST_UPDATED_RANGE_FILTER_FIELD = 'CT_LAST_UPDATED_RANGE_FILTER_FIELD';
export const CT_CONTENT_PARTNER_FILTER_FIELD = 'CT_CONTENT_PARTNER_FILTER_FIELD';
export const CT_CAMPAIGN_MANAGER_EMAIL_FILTER_FIELD = 'CT_CAMPAIGN_MANAGER_EMAIL_FILTER_FIELD';
export const CT_MEDIAFILE_URL_FILTER_FIELD = 'CT_MEDIAFILE_URL_FILTER_FIELD';
export const CT_CREATIVE_TYPE_FILTER_FIELD = 'CT_CREATIVE_TYPE_FILTER_FIELD';
export const CT_COUNTRY_FILTER_FIELD = 'CT_COUNTRY_FILTER_FIELD';
export const CT_TRACKING_ID_FILTER_FIELD = 'CT_TRACKING_ID_FILTER_FIELD';
export const CT_EXTERNAL_PARTNER_FILTER_FIELD = 'CT_EXTERNAL_PARTNER_FILTER_FIELD';
export const CT_SUBCLASS_FILTER_FIELD = 'CT_SUBCLASS_FILTER_FIELD';
export const CT_CREATIVE_ID_FILTER_FIELD = 'CT_CREATIVE_ID_FILTER_FIELD';
export const CT_INGESTION_TYPE_FILTER_FIELD = 'CT_INGESTION_TYPE_FILTER_FIELD';

// CT Table Columns
export const CT_ASSET_ID_TABLE_COLUMN = 'CT_ASSET_ID_TABLE_COLUMN';
export const CT_BRAND_NAME_TABLE_COLUMN = 'CT_BRAND_NAME_TABLE_COLUMN';
export const CT_UPDATED_AT_TABLE_COLUMN = 'CT_UPDATED_AT_TABLE_COLUMN';
export const CT_CREATED_AT_TABLE_COLUMN = 'CT_CREATED_AT_TABLE_COLUMN';
export const CT_STATUS_TABLE_COLUMN = 'CT_STATUS_TABLE_COLUMN';
export const CT_TRACKING_ID_TABLE_COLUMN = 'CT_TRACKING_ID_TABLE_COLUMN';
export const CT_ASSET_NAME_TABLE_COLUMN = 'CT_ASSET_NAME_TABLE_COLUMN';
export const CT_SOURCE_AD_ID_TABLE_COLUMN = 'CT_SOURCE_AD_ID_TABLE_COLUMN';
export const CT_SOURCE_CREATIVE_ID_TABLE_COLUMN = 'CT_SOURCE_CREATIVE_ID_TABLE_COLUMN';
export const CT_ADOMAIN_TABLE_COLUMN = 'CT_ADOMAIN_TABLE_COLUMN';
export const CT_MEDIAFILE_URL_TABLE_COLUMN = 'CT_MEDIAFILE_URL_TABLE_COLUMN';
export const CT_PREVIEW_TABLE_COLUMN = 'CT_PREVIEW_TABLE_COLUMN';

export const TABLE_COLUMNS_MAP_V2 = {
  [ASSET_NAME_KEY]: CT_ASSET_NAME_TABLE_COLUMN,
  [ASSET_ID_KEY]: CT_ASSET_ID_TABLE_COLUMN,
  [BRAND_NAME_KEY]: CT_BRAND_NAME_TABLE_COLUMN,
  [UPDATED_AT_KEY]: CT_UPDATED_AT_TABLE_COLUMN,
  [CREATED_AT_KEY]: CT_CREATED_AT_TABLE_COLUMN,
  [REVIEW_STATUS_KEY]: CT_STATUS_TABLE_COLUMN,
  [TRACKING_ID_KEY]: CT_TRACKING_ID_TABLE_COLUMN,
  [SOURCE_AD_ID_KEY]: CT_SOURCE_AD_ID_TABLE_COLUMN,
  [SOURCE_CREATIVE_ID_KEY]: CT_SOURCE_CREATIVE_ID_TABLE_COLUMN,
  [MEDIA_FILE_URL_KEY]: CT_MEDIAFILE_URL_TABLE_COLUMN,
  [TRANSCODE_QC_PLAYLIST_KEY]: CT_PREVIEW_TABLE_COLUMN,
  [ADOMAIN_KEY]: CT_ADOMAIN_TABLE_COLUMN,
};

export const FILTER_FIELDS_MAP_V2 = {
  [PUBLISHERS_KEY]: CT_PUBLISHER_FILTER_FIELD,
  [SOURCE_AD_IDS_KEY]: CT_SOURCE_AD_ID_FILTER_FIELD,
  [SOURCE_CREATIVE_IDS_KEY]: CT_SOURCE_CREATIVE_ID_FILTER_FIELD,
  [ASSET_IDS_KEY]: CT_ASSET_ID_FILTER_FIELD,
  [BRAND_CRM_IDS_KEY]: CT_BRAND_NAME_FILTER_FIELD,
  [ADOMAINS_KEY]: CT_ADOMAIN_FILTER_FIELD,
  [DSP_IDS_KEY]: CT_DSP_FILTER_FIELD,
  [REVIEW_STATUSES_KEY]: CT_REVIEW_STATUS_FILTER_FIELD,
  [LAST_UPDATED_RANGE]: CT_LAST_UPDATED_RANGE_FILTER_FIELD,
  [CONTENT_PARTNER_IDS_KEY]: CT_CONTENT_PARTNER_FILTER_FIELD,
  [CAMPAIGN_MANAGER_NAME_KEY]: CT_CAMPAIGN_MANAGER_EMAIL_FILTER_FIELD,
  [MEDIA_FILE_URL_KEY]: CT_MEDIAFILE_URL_FILTER_FIELD,
  [CREATIVE_TYPES_KEY]: CT_CREATIVE_TYPE_FILTER_FIELD,
  [COUNTRY_CODES_KEY]: CT_COUNTRY_FILTER_FIELD,
  [TRACKING_IDS_KEY]: CT_TRACKING_ID_FILTER_FIELD,
  [ASSET_SOURCE_EXTERNAL_PARTNERS_KEY]: CT_EXTERNAL_PARTNER_FILTER_FIELD,
  [SUBCLASS_KEY]: CT_SUBCLASS_FILTER_FIELD,
  [CREATIVE_ID_KEY]: CT_CREATIVE_ID_FILTER_FIELD,
  [INGESTION_TYPES_KEY]: CT_INGESTION_TYPE_FILTER_FIELD,
  [AD_ID_KEY]: CT_AD_ID_FILTER_FIELD,
};
